/**
 * Generato automaticamente.
 * OpenAPI
 */
import { useMutation, useQuery } from 'react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type {
  GetImmaginiAltParams,
  GetImmaginiExportParams,
  GetImmaginiParams,
  GetImmaginiUidParams,
  ImmagineDTO,
  MetadatiAltImmaginiDTO,
  MetadatiImmagineDTO,
  PostImmaginiBodyOne,
  PostImmaginiBodyTwo,
  PostImmaginiParams,
  PutImmaginiUidBodyOne,
  PutImmaginiUidBodyTwo,
  PutImmaginiUidParams,
  WsProblema,
  WsRispostaPaginataListMetadatiImmagineDTO,
} from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Recupera l'immagine in base alla lingua richiesta.
 * @summary Recupera Immagine
 */
export const getImmaginiUid = (
  uid: string,
  params?: GetImmaginiUidParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<string[]>(
    {
      url: `/framework-cfg-domande/immagini/${uid}`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetImmaginiUidQueryKey = (
  uid: string,
  params?: GetImmaginiUidParams,
) =>
  [
    `/framework-cfg-domande/immagini/${uid}`,
    ...(params ? [params] : []),
  ] as const;

export const getGetImmaginiUidQueryOptions = <
  TData = Awaited<ReturnType<typeof getImmaginiUid>>,
  TError = ErrorType<WsProblema>,
>(
  uid: string,
  params?: GetImmaginiUidParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getImmaginiUid>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getImmaginiUid>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetImmaginiUidQueryKey(uid, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getImmaginiUid>>> = ({
    signal,
  }) => getImmaginiUid(uid, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!uid, ...queryOptions };
};

export type GetImmaginiUidQueryResult = NonNullable<
  Awaited<ReturnType<typeof getImmaginiUid>>
>;
export type GetImmaginiUidQueryError = ErrorType<WsProblema>;

/**
 * @summary Recupera Immagine
 */
export const useGetImmaginiUid = <
  TData = Awaited<ReturnType<typeof getImmaginiUid>>,
  TError = ErrorType<WsProblema>,
>(
  uid: string,
  params?: GetImmaginiUidParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getImmaginiUid>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetImmaginiUidQueryOptions(uid, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Modifica un'immagine oppure carica una sua traduzione in base al valore di Accept-Language.
 * @summary Aggiorna o Carica traduzione Immagine
 */
export const putImmaginiUid = (
  uid: string,
  putImmaginiUidBody: PutImmaginiUidBodyOne | PutImmaginiUidBodyTwo,
  params?: PutImmaginiUidParams,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<MetadatiImmagineDTO>(
    {
      url: `/framework-cfg-domande/immagini/${uid}`,
      method: 'put',
      data: putImmaginiUidBody,
      params,
    },
    options,
  );
};

export const getPutImmaginiUidMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putImmaginiUid>>,
    TError,
    {
      uid: string;
      data: PutImmaginiUidBodyOne | PutImmaginiUidBodyTwo;
      params?: PutImmaginiUidParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putImmaginiUid>>,
  TError,
  {
    uid: string;
    data: PutImmaginiUidBodyOne | PutImmaginiUidBodyTwo;
    params?: PutImmaginiUidParams;
  },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putImmaginiUid>>,
    {
      uid: string;
      data: PutImmaginiUidBodyOne | PutImmaginiUidBodyTwo;
      params?: PutImmaginiUidParams;
    }
  > = props => {
    const { uid, data, params } = props ?? {};

    return putImmaginiUid(uid, data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutImmaginiUidMutationResult = NonNullable<
  Awaited<ReturnType<typeof putImmaginiUid>>
>;
export type PutImmaginiUidMutationBody =
  | PutImmaginiUidBodyOne
  | PutImmaginiUidBodyTwo;
export type PutImmaginiUidMutationError = ErrorType<unknown>;

/**
 * @summary Aggiorna o Carica traduzione Immagine
 */
export const usePutImmaginiUid = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putImmaginiUid>>,
    TError,
    {
      uid: string;
      data: PutImmaginiUidBodyOne | PutImmaginiUidBodyTwo;
      params?: PutImmaginiUidParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPutImmaginiUidMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Rimuove un'immagine. Se si rimuove l'immagine it-IT, vengono rimosse anche le sue traduzioni.
 * @summary Elimina Immagine
 */
export const deleteImmaginiUid = (
  uid: string,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<void>(
    { url: `/framework-cfg-domande/immagini/${uid}`, method: 'delete' },
    options,
  );
};

export const getDeleteImmaginiUidMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteImmaginiUid>>,
    TError,
    { uid: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteImmaginiUid>>,
  TError,
  { uid: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteImmaginiUid>>,
    { uid: string }
  > = props => {
    const { uid } = props ?? {};

    return deleteImmaginiUid(uid, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteImmaginiUidMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteImmaginiUid>>
>;

export type DeleteImmaginiUidMutationError = ErrorType<WsProblema>;

/**
 * @summary Elimina Immagine
 */
export const useDeleteImmaginiUid = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteImmaginiUid>>,
    TError,
    { uid: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getDeleteImmaginiUidMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Ritorna la lista delle immagini.
 * @summary Lista Immagini
 */
export const getImmagini = (
  params?: GetImmaginiParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<WsRispostaPaginataListMetadatiImmagineDTO>(
    { url: `/framework-cfg-domande/immagini`, method: 'get', params, signal },
    options,
  );
};

export const getGetImmaginiQueryKey = (params?: GetImmaginiParams) =>
  [`/framework-cfg-domande/immagini`, ...(params ? [params] : [])] as const;

export const getGetImmaginiQueryOptions = <
  TData = Awaited<ReturnType<typeof getImmagini>>,
  TError = ErrorType<unknown>,
>(
  params?: GetImmaginiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getImmagini>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<Awaited<ReturnType<typeof getImmagini>>, TError, TData> & {
  queryKey: QueryKey;
} => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetImmaginiQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getImmagini>>> = ({
    signal,
  }) => getImmagini(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetImmaginiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getImmagini>>
>;
export type GetImmaginiQueryError = ErrorType<unknown>;

/**
 * @summary Lista Immagini
 */
export const useGetImmagini = <
  TData = Awaited<ReturnType<typeof getImmagini>>,
  TError = ErrorType<unknown>,
>(
  params?: GetImmaginiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getImmagini>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetImmaginiQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Aggiungi una nuova immagine alla galleria (solo per it-IT)
 * @summary Aggiungi Immagine
 */
export const postImmagini = (
  postImmaginiBody: PostImmaginiBodyOne | PostImmaginiBodyTwo,
  params?: PostImmaginiParams,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<MetadatiImmagineDTO>(
    {
      url: `/framework-cfg-domande/immagini`,
      method: 'post',
      data: postImmaginiBody,
      params,
    },
    options,
  );
};

export const getPostImmaginiMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postImmagini>>,
    TError,
    {
      data: PostImmaginiBodyOne | PostImmaginiBodyTwo;
      params?: PostImmaginiParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postImmagini>>,
  TError,
  {
    data: PostImmaginiBodyOne | PostImmaginiBodyTwo;
    params?: PostImmaginiParams;
  },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postImmagini>>,
    {
      data: PostImmaginiBodyOne | PostImmaginiBodyTwo;
      params?: PostImmaginiParams;
    }
  > = props => {
    const { data, params } = props ?? {};

    return postImmagini(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostImmaginiMutationResult = NonNullable<
  Awaited<ReturnType<typeof postImmagini>>
>;
export type PostImmaginiMutationBody =
  | PostImmaginiBodyOne
  | PostImmaginiBodyTwo;
export type PostImmaginiMutationError = ErrorType<unknown>;

/**
 * @summary Aggiungi Immagine
 */
export const usePostImmagini = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postImmagini>>,
    TError,
    {
      data: PostImmaginiBodyOne | PostImmaginiBodyTwo;
      params?: PostImmaginiParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostImmaginiMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Aggiungi una nuova immagine alla galleria
 * @summary Aggiungi Immagine per import procedimenti
 */
export const postImmaginiImport = (
  immagineDTO: ImmagineDTO[],
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<void>(
    {
      url: `/framework-cfg-domande/immagini/import`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: immagineDTO,
    },
    options,
  );
};

export const getPostImmaginiImportMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postImmaginiImport>>,
    TError,
    { data: ImmagineDTO[] },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postImmaginiImport>>,
  TError,
  { data: ImmagineDTO[] },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postImmaginiImport>>,
    { data: ImmagineDTO[] }
  > = props => {
    const { data } = props ?? {};

    return postImmaginiImport(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostImmaginiImportMutationResult = NonNullable<
  Awaited<ReturnType<typeof postImmaginiImport>>
>;
export type PostImmaginiImportMutationBody = ImmagineDTO[];
export type PostImmaginiImportMutationError = ErrorType<unknown>;

/**
 * @summary Aggiungi Immagine per import procedimenti
 */
export const usePostImmaginiImport = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postImmaginiImport>>,
    TError,
    { data: ImmagineDTO[] },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostImmaginiImportMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Ritorna la lista delle immagini.
 * @summary Lista Immagini
 */
export const getImmaginiUidTraduzioni = (
  uid: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<MetadatiImmagineDTO[]>(
    {
      url: `/framework-cfg-domande/immagini/${uid}/traduzioni`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetImmaginiUidTraduzioniQueryKey = (uid: string) =>
  [`/framework-cfg-domande/immagini/${uid}/traduzioni`] as const;

export const getGetImmaginiUidTraduzioniQueryOptions = <
  TData = Awaited<ReturnType<typeof getImmaginiUidTraduzioni>>,
  TError = ErrorType<unknown>,
>(
  uid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getImmaginiUidTraduzioni>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getImmaginiUidTraduzioni>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetImmaginiUidTraduzioniQueryKey(uid);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getImmaginiUidTraduzioni>>
  > = ({ signal }) => getImmaginiUidTraduzioni(uid, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!uid, ...queryOptions };
};

export type GetImmaginiUidTraduzioniQueryResult = NonNullable<
  Awaited<ReturnType<typeof getImmaginiUidTraduzioni>>
>;
export type GetImmaginiUidTraduzioniQueryError = ErrorType<unknown>;

/**
 * @summary Lista Immagini
 */
export const useGetImmaginiUidTraduzioni = <
  TData = Awaited<ReturnType<typeof getImmaginiUidTraduzioni>>,
  TError = ErrorType<unknown>,
>(
  uid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getImmaginiUidTraduzioni>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetImmaginiUidTraduzioniQueryOptions(uid, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Ritorna la lista delle immagini.
 * @summary Lista Immagini per export procedimenti
 */
export const getImmaginiExport = (
  params: GetImmaginiExportParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<ImmagineDTO[]>(
    {
      url: `/framework-cfg-domande/immagini/export`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetImmaginiExportQueryKey = (params: GetImmaginiExportParams) =>
  [
    `/framework-cfg-domande/immagini/export`,
    ...(params ? [params] : []),
  ] as const;

export const getGetImmaginiExportQueryOptions = <
  TData = Awaited<ReturnType<typeof getImmaginiExport>>,
  TError = ErrorType<unknown>,
>(
  params: GetImmaginiExportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getImmaginiExport>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getImmaginiExport>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetImmaginiExportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getImmaginiExport>>
  > = ({ signal }) => getImmaginiExport(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetImmaginiExportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getImmaginiExport>>
>;
export type GetImmaginiExportQueryError = ErrorType<unknown>;

/**
 * @summary Lista Immagini per export procedimenti
 */
export const useGetImmaginiExport = <
  TData = Awaited<ReturnType<typeof getImmaginiExport>>,
  TError = ErrorType<unknown>,
>(
  params: GetImmaginiExportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getImmaginiExport>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetImmaginiExportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Ritorna la lista dei testi alternativi immagini.
 * @summary Lista testi alternativi Immagini
 */
export const getImmaginiAlt = (
  params: GetImmaginiAltParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<MetadatiAltImmaginiDTO>(
    {
      url: `/framework-cfg-domande/immagini/alt`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetImmaginiAltQueryKey = (params: GetImmaginiAltParams) =>
  [`/framework-cfg-domande/immagini/alt`, ...(params ? [params] : [])] as const;

export const getGetImmaginiAltQueryOptions = <
  TData = Awaited<ReturnType<typeof getImmaginiAlt>>,
  TError = ErrorType<unknown>,
>(
  params: GetImmaginiAltParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getImmaginiAlt>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getImmaginiAlt>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetImmaginiAltQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getImmaginiAlt>>> = ({
    signal,
  }) => getImmaginiAlt(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetImmaginiAltQueryResult = NonNullable<
  Awaited<ReturnType<typeof getImmaginiAlt>>
>;
export type GetImmaginiAltQueryError = ErrorType<unknown>;

/**
 * @summary Lista testi alternativi Immagini
 */
export const useGetImmaginiAlt = <
  TData = Awaited<ReturnType<typeof getImmaginiAlt>>,
  TError = ErrorType<unknown>,
>(
  params: GetImmaginiAltParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getImmaginiAlt>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetImmaginiAltQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
